import { Colors } from "assets/colors";

export const styles: any = {
  cardContainer: {
    marginTop: ".5rem"
  },
  boxContainer:{
    width:'100%',
    padding: '15px',
    borderRadius: '5px',
    background: 'white',
    minHeight:'100px',
    height: 'auto',
    border: '1px solid #DAE1E7'
  },
  subTitle: {
    fontSize: '14px',
    fontWeight: '600', 
    color: '#7C7B7B', 
    position:'absolute', 
    right:'200px',
    top: '42px', 
    zIndex: '1030'
  },
  subTitleRht: {
    fontSize: '14px',
    fontWeight: '600', 
    color: '#7C7B7B', 
    marginTop: '40px', 
    position:'absolute', 
    right:'50px',
    zIndex: '1030'
  },
  FlexCont:{
    display: 'flex', 
    alignItems: 'start', 
    justifyContent:'center', 
    flexDirection:'column',
    paddingTop:'2px;'
  },
  para:{
    fontSize: '12px', 
    fontWeight: '600', 
    paddingLeft: '10px', 
    color: '#7C7B7B', 
    lineHeight: '1.22rem'}
} 
